module.exports = __webpack_public_path__ + "static/media/jpg.5ffbc9bc.svg";